 <ng-container *ngFor="let item of items; let i = index">
<tr [ngClass]="{'bg-[#EBF2FF]': item.selected, 'bg-[#F7F7F7]': item.expanded && !item.selected,'border-l-[#DEB900]': isChild}" class="border group border-t-[#e4e7ec] border-l-2 border-r-transparent border-b-0 border-l-[#9747FF]">
              <ng-container *ngFor="let column of columns; let colIndex = index">
                <td *ngIf="column.type == 'Index'" class="px-4 flex items-center h-16">
                  <div class="flex justify-center items-center">
                    <input *ngIf="!isChild" class="cursor-pointer" type="checkbox" [(ngModel)]="item.selected" (click)="toggleParentSelection(item)">
                  </div>
                </td>
                <td *ngIf="column.type == 'Value'" [ngClass]="{'bg-[#3F41D11F] ': column.highlight==true, 'sticky right-0 left-0 mt-[1px]' : column.sticky == true, 'bg-[#EBF2FF]': column.sticky && item.selected, 'bg-white': column.sticky && !item.selected,'text-[#666666]': isChild}" class="px-4 h-16 items-center">
                  <div class="flex items-center gap-2">
                    <img *ngIf="column.children== true && item.children?.length" src="../../../assets/CaretUp.svg" alt="Caret Up" class="cursor-pointer transition-transform duration-200" [class.rotate-180]="!item.expanded" [class.rotate-360]="item.expanded" (click)="toggleExpand(item)" />  
                    <ng-container>
                      <div [class]="column?.class" class="flex flex-row gap-2 items-center">
                        <input *ngIf="isChild && colIndex == 1" class="cursor-pointer" type="checkbox" [(ngModel)]="item.selected"  (click)="onCheckboxClick($event, item)">
                         <!-- Default Text Value -->
                         <ng-container>
                             <span class="truncate">
                               {{ column.uppercase ? (item[column.key] | uppercase) : (item[column.key] || '-') }}
                             </span>
                         </ng-container>
                        <img *ngIf="!isChild && column?.optional_button" class="cursor-pointer min-w-5 max-w-5 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100" (click)="column?.optional_button(item,i)" src="../../../assets/add_icon_with_border.svg" alt="">
                      </div>
                    </ng-container>
                  </div>
                </td>

                <td *ngIf="column?.type == 'Date'">
                  <ng-container *ngIf="column.type === 'Date' || column.type === 'date'">
                            {{ item[column.key] | date: 'dd-MM-yyyy' }}
                          </ng-container>
                </td>

                <td *ngIf="column.type == 'Pills'">
                   <ng-container *ngIf="!isChild">
                        <div class="flex justify-center items-center w-full">
                          <button class="px-[10px] py-1 rounded-md border text-sm font-medium" 
                           [ngStyle]="{
                             'color': getPillColor(column, item),
                             'border-color': getPillColor(column, item)
                           }">
                            {{ item[column.key] }}
                          </button>
                        </div>
                      </ng-container>
                      <div *ngIf="isChild" class="flex justify-center items-center">
                        <button class="px-2 py-1 rounded-full border-none text-sm font-medium flex justify-center items-center" [ngStyle]="{'color': getPillColor(column, item),'border-color': getPillColor(column, item),}">
                          <div class="h-2 w-2 rounded-full mr-[6px]" [ngStyle]="{'color': getPillColor(column, item),'border-color': getPillColor(column, item),'background-color': getPillColor(column, item)}"></div>
                          {{ item[column.key] }}
                        </button>
                      </div>
                </td>

                <td *ngIf="column.type == 'Action'" class="px-4 h-16 mt-4">
                  <div class="flex items-center justify-center">
                    <!-- <img class="h-6 min-w-6 cursor-pointer" src="https://static.thenounproject.com/png/2854151-200.png" alt="Menu" (click)="toggleMenu(i) ; $event.stopPropagation()" /> -->
                      <app-mini-modal image_class="h-6 min-w-6 -mb-2 cursor-pointer" image="https://static.thenounproject.com/png/2854151-200.png" >
                        <div class="bg-[#E8E8F9] h-auto rounded-[4px] shadow-md" (click)="$event.stopPropagation()">
                          <ng-container *ngFor="let action of column.actions">
                            <div *ngIf="!action.show || action.show(item)" (click)="action.action(item,i); menuVisibleIndex = null" class="flex px-3 min-w-[175px] justify-start items-center text-sm font-normal leading-5 tracking-wide gap-3 py-2 cursor-pointer hover:bg-[#e2e0f9] transition-all">
                              <img [src]="action.icon" alt="" />
                              <span [ngClass]="{'text-red-500': action.title == 'Delete'}">{{ action.title }}</span>
                            </div>
                          </ng-container>
                        </div>
                      </app-mini-modal>
                  </div>
                </td>
              </ng-container>
            </tr>
            <!-- Expand Child Rows -->
          <tr class="contents" *ngIf="item.expanded">
            <td class="contents">
              <table class="contents">
                <tbody class="contents">
                  <app-table-row [items]="item.children" [columns]="columns" [isChild]="true"></app-table-row>
                </tbody>
              </table>
            </td>
          </tr>
  </ng-container>

  